import { GeneratedSkedApiClient } from "../generated-client";
import type { paths } from "../generated/sked-api-openapi-types";

type UpdateAssetOperation = paths["/content-inbox/{assetId}"]["put"];
type UpdateAssetBody = NonNullable<
  UpdateAssetOperation["requestBody"]
>["content"]["application/json"];
type UpdateAssetResponse =
  UpdateAssetOperation["responses"][200]["content"]["application/json"];

const generatedSkedApiClient = new GeneratedSkedApiClient<paths>();

export async function updateAsset(
  assetId: string,
  input: UpdateAssetBody
): Promise<UpdateAssetResponse> {
  const result = await generatedSkedApiClient.client.PUT(
    "/content-inbox/{assetId}",
    {
      params: {
        path: { assetId },
      },
      body: input,
    }
  );

  return (await generatedSkedApiClient.unwrap(result)) as UpdateAssetResponse;
}
